import React from "react";
import PropTypes from "prop-types";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";

/** Email-already-exists confirmation (historic guardian debounced flows). */
export default function HistoricEmailExistsDialog({
  open,
  onClose,
  onCancel,
  onContinue,
}) {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Email Already Exists</DialogTitle>
      <DialogContent>
        <DialogContentText>
          This email already exists. Would you like to continue with this email?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} color="secondary">
          Cancel
        </Button>
        <Button onClick={onContinue} color="primary" autoFocus>
          Continue
        </Button>
      </DialogActions>
    </Dialog>
  );
}

HistoricEmailExistsDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  onContinue: PropTypes.func.isRequired,
};
